import { 
  collection, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  getDocs,
  getDoc,
  query,
  orderBy 
} from 'firebase/firestore';
import { db } from '../config/firebase';

const COLLECTION_NAME = 'equipment';

export const getAllEquipment = async () => {
  try {
    const q = query(collection(db, COLLECTION_NAME), orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    const equipment = [];
    querySnapshot.forEach((doc) => {
      equipment.push({ id: doc.id, ...doc.data() });
    });
    return { success: true, data: equipment };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const getEquipment = async (id) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      return { success: true, data: { id: docSnap.id, ...docSnap.data() } };
    } else {
      return { success: false, error: 'Equipment not found' };
    }
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const createEquipment = async (equipmentData) => {
  try {
    const docRef = await addDoc(collection(db, COLLECTION_NAME), {
      ...equipmentData,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    });

    return { success: true, id: docRef.id };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const updateEquipment = async (id, equipmentData) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(docRef, {
      ...equipmentData,
      updatedAt: new Date().toISOString()
    });
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const deleteEquipment = async (id) => {
  try {
    await deleteDoc(doc(db, COLLECTION_NAME, id));
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};